import _ from "lodash";
import fieldHelpers from "../../../../ui-formly/fieldHelpers/index";
import { defaultModelOptions } from "../../../../utils/modelOptions";
import userServer from "../../../server/index";

function formly(server, asyncValidators) {
  var fields = [
    fieldHelpers.columnLayout(
      [
        {
          key: "Name",
          name: "Name",
          type: "input",
          templateOptions: {
            label: "Title Name",
            required: true,
          },
          asyncValidators: {
            unique: {
              expression: asyncValidators.uniqueTitleName,
            },
          },
          validation: {
            messages: {
              unique: function () {
                return "Title Name is not unique";
              },
            },
          },
          modelOptions: defaultModelOptions,
          expressionProperties: {
            "templateOptions.readonly": "!!model.Id",
          },
        },
      ],
      3
    ),
    fieldHelpers.columnLayout(
      [
        {
          key: "Roles",
          name: "Roles",
          type: "multiCheckbox",
          templateOptions: {
            label: "Roles",
            options: [],
            valueProp: "Id",
            labelProp: "RoleName",
          },
          controller: [
            "$scope",
            userServer.vsName,
            function ($scope, server) {
              server
                .getRolesQuery({
                  Take: 1000,
                  OrderBy: "RoleName",
                })
                .then(function (roles) {
                  var options = [];
                  _.forEach(roles.Results, function (item) {
                    options.push(item);
                  });
                  $scope.to.options = options;
                });
            },
          ],
        },
      ],
      1
    ),
  ];

  return _.flatten(fields, false);
}

export default formly;
